import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { ActionGuard, LoginGuard } from 'src/app/components/core/_infrastructure/classes/guards/main.guard';
import { CultivoWrapperComponent } from './cultivo-wrapper/cultivo-wrapper.component';
import { CultivoWrapperEditComponent } from './cultivo-wrapper-edit/cultivo-wrapper-edit.component';

const cultivosRoutes: Routes = [
    {
        path: 'campanias/recinto/cultivos/:id', // En éste caso, el id será el del recinto
        data: {
            menu1: 'Cultivos',
            menu0: 'Campañas',
        },
        children: [
            {
                path: '',
                component: CultivoWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Listado de Cultivos',
                    actionCode: EnumCodigosTwTcAcciones.MENU_CULTIVO_CAMPANIA,
                },
            },
            {
                path: 'edit/:idCultivo',
                component: CultivoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Datos del Cultivo',
                    actionCode: EnumCodigosTwTcAcciones.MENU_CULTIVO_CAMPANIA,
                },
            },
            {
                path: 'view/:idCultivo',
                component: CultivoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    readonly: true,
                    breadcrumb: 'Datos del Cultivo',
                    actionCode: EnumCodigosTwTcAcciones.MENU_CULTIVO_CAMPANIA,
                },
            },
            {
                path: 'create',
                component: CultivoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Cultivo',
                    actionCode: EnumCodigosTwTcAcciones.MENU_CULTIVO_CAMPANIA,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(cultivosRoutes)],
    exports: [RouterModule],
})
export class CultivoRoutingModule {}
